document.addEventListener('DOMContentLoaded', function () {
  const PR = window.PRPurchase;
  const productForm = document.querySelector('.product-single__form');
  if (!productForm || !PR) return;
  const root = productForm.closest('[data-pr-pdp]');
  if (!root || root.dataset.prFlavor !== 'oil') return;

  const FREE_SHIPPING_THRESHOLD_CENTS = PR.FREE_SHIPPING_THRESHOLD_CENTS;
  const productData = PR.readProduct(productForm);
  const plans = PR.readPlans();
  const productContainer = root.querySelector('.custom-subscription-widget-container');
  if (!productContainer || !productData) return;

  const subscriptionIdInput = productForm.querySelector('input[name="selling_plan"]');
  const variantIdInput = productForm.querySelector('[name="id"]');
  const btnTextElement = productForm.querySelector('.btn--add-to-cart .btn__text');
  const shippingPriceElement = productContainer.querySelector('#buy-once-option .shipping-price');
  const packButtons = productContainer.querySelectorAll('.pack-button');

  let selectedBuyOncePack = '1-Pack';

  const getVariant = function (pack) {
    const lower = String(pack).toLowerCase();
    const bottles = PR.parsePack(pack);
    return (
      productData.variants.find(function (v) {
        return v.option1 === pack;
      }) ||
      productData.variants.find(function (v) {
        return v.option1 && v.option1.toLowerCase() === lower;
      }) ||
      productData.variants.find(function (v) {
        return PR.parsePack(v.option1) === bottles || PR.parsePack(v.option2) === bottles;
      })
    );
  };

  const unitPrice = function () {
    const one = getVariant('1-Pack');
    return one && one.price > 0 ? one.price : 6500;
  };

  const formulaBase = function (pack) {
    return PR.parsePack(pack) * unitPrice();
  };

  const bottlesLabel = function (n) {
    return n === 1 ? '1 bottle' : n + ' bottles';
  };

  // `planId` comes from data-plan-id on the radio (see pr-rtx-oil.liquid). This
  // product has several monthly/threeMonth allocations, so kind alone picks the
  // wrong one.
  const getTargetData = function (isSubscription, pack, kind, planId) {
    const variant = getVariant(pack);
    if (!variant) return { variant: null, price: 0, sellingPlan: '' };
    const record = PR.variantRecord(plans, variant.id);
    if (isSubscription) {
      const alloc = PR.allocation(record, kind, planId);
      if (alloc && alloc.price > 0) {
        return { variant: variant, price: alloc.price, sellingPlan: alloc.plan_id };
      }
    }
    return { variant: variant, price: variant.price, sellingPlan: '' };
  };

  const updateLabels = function () {
    const monthlyEl = productContainer.querySelector('.js-monthly-qty');
    if (monthlyEl) monthlyEl.textContent = bottlesLabel(1);
    const threeEl = productContainer.querySelector('.js-three-month-qty');
    if (threeEl) threeEl.textContent = bottlesLabel(3);
    const sixEl = productContainer.querySelector('.js-six-month-qty');
    if (sixEl) sixEl.textContent = bottlesLabel(6);
    const onceEl = productContainer.querySelector('.js-buy-once-count');
    if (onceEl) onceEl.textContent = bottlesLabel(PR.parsePack(selectedBuyOncePack) || 1);
  };

  const updateFormAndPrices = function () {
    const selectedRadio = productContainer.querySelector('input[name="purchase_option"]:checked');
    if (!selectedRadio) return;
    const kind = selectedRadio.dataset.planKind || 'onetime';
    const isSubscription = kind !== 'onetime';
    const mult = parseInt(selectedRadio.dataset.countMultiplier, 10) || 1;
    const pack = isSubscription ? PR.packLabel(mult) : selectedBuyOncePack;
    const data = getTargetData(isSubscription, pack, kind, selectedRadio.dataset.planId);
    if (!data.variant) return;

    if (variantIdInput) {
      variantIdInput.value = data.variant.id;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (subscriptionIdInput) subscriptionIdInput.value = data.sellingPlan || '';

    const buyOnceLabel = productContainer.querySelector('#buy-once-option');
    if (buyOnceLabel) {
      const once = getTargetData(false, selectedBuyOncePack, 'onetime');
      if (once.variant) {
        PR.fillPriceDetails(buyOnceLabel, once.price, formulaBase(selectedBuyOncePack), 1, true);
        // The card's shipping line sits under the price now, so it is priced
        // from the one-time allocation rather than the selected option.
        if (shippingPriceElement) {
          shippingPriceElement.textContent =
            once.price >= FREE_SHIPPING_THRESHOLD_CENTS ? 'Free Shipping' : '+ ' + PR.shippingText(productContainer);
        }
      }
    }

    productContainer.querySelectorAll('.purchase-option-label:not(.purchase-option-onetime)').forEach(function (label) {
      const radio = label.querySelector('input[name="purchase_option"]');
      if (!radio) return;
      const k = radio.dataset.planKind;
      const m = parseInt(radio.dataset.countMultiplier, 10) || 1;
      const vd = getTargetData(true, PR.packLabel(m), k, radio.dataset.planId);
      if (vd.variant) {
        PR.fillPriceDetails(label, vd.price, formulaBase(PR.packLabel(m)), m, false);
        radio.dataset.sellingPlanId = vd.sellingPlan || '';
      }
    });

    updateLabels();
    productContainer.querySelectorAll('.pack-save-badge[data-pack-save-badge]').forEach(function (badge) {
      const packVal = badge.dataset.packSaveBadge;
      const variant = getVariant(packVal);
      if (!variant) {
        badge.textContent = '';
        return;
      }
      const base = formulaBase(packVal);
      badge.textContent = base > variant.price ? 'Save ' + Math.round(((base - variant.price) / base) * 100) + '%' : '';
    });

    if (btnTextElement) btnTextElement.textContent = PR.ctaText(productContainer, data.variant.available);
  };

  packButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      packButtons.forEach(function (b) {
        b.classList.remove('is-selected-pack');
      });
      button.classList.add('is-selected-pack');
      selectedBuyOncePack = button.dataset.packValue;
      const current = productContainer.querySelector('input[name="purchase_option"]:checked');
      if (current && current.value === 'onetime') updateFormAndPrices();
    });
  });

  PR.bindBuyOncePackReset(productContainer, function (pack) {
    selectedBuyOncePack = pack;
    updateFormAndPrices();
  });

  productContainer.querySelectorAll('input[name="purchase_option"]').forEach(function (radio) {
    radio.addEventListener('change', updateFormAndPrices);
  });

  PR.bindSelection(productContainer);
  PR.bindBanner(root);
  PR.bindVideos(root);
  updateFormAndPrices();
});
